export enum ServiceTypeEnum {
  gameRecording = "game-recording",
  additional = "additional",
}
